import { createAsyncThunk } from "@reduxjs/toolkit";
import { allTenant } from "../../../api/tenant_api";


export const allTenantAction = createAsyncThunk(
  "tenant/all",
  async (values, { rejectWithValue, getState }) => {
    try {
      const result = await allTenant(values);
      return result;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);